﻿export default function TableSkeleton({ rows = 4, columns = 4 }) {
  return (
    <tbody className="animate-pulse bg-white divide-y divide-border">
      {[...Array(rows)].map((_, rowIndex) => (
        <tr key={rowIndex}>
          {[...Array(columns)].map((_, colIndex) => (
            <td key={colIndex} className="px-6 py-2 whitespace-nowrap">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
